import { useTranslation } from '@portals-platform/i18n';
import { CheckboxField } from '@portals-platform/ui-forms';
import { useFieldText } from '../../../hooks/use-field-text.js';
import { FIELD_CONFIG } from '../../../lib/new-certificate/fields.js';
import { CertificateSection } from './certificate-section.js';

export function ComplianceSection() {
  const { t } = useTranslation();
  const { label } = useFieldText(FIELD_CONFIG.sanctionedCountryTouchpoint);

  return (
    <CertificateSection title={t('certificates.new.sections.sanctionedCountryTouchpoint')}>
      <div className="rounded-[var(--radius-md)] border border-[color:var(--color-warning)] px-4 py-2">
        <CheckboxField name="sanctionedCountryTouchpoint" label={label} />
      </div>
    </CertificateSection>
  );
}
